import { render } from "./EnbPedidos01.vue?vue&type=template&id=586827ca&scoped=true"
import script from "./EnbPedidos01.vue?vue&type=script&lang=js"
export * from "./EnbPedidos01.vue?vue&type=script&lang=js"

import "./EnbPedidos01.vue?vue&type=style&index=0&id=586827ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586827ca"]])

export default __exports__